import BasicDatePicker from '@components/form/date-picker/BasicDatePicker';
import {RHFAutocomplete} from 'src/minimal-components/hook-form';
import {CircularProgressDiv} from '@modules/public/main/login/LoginStyles';
import {LoadingButton} from '@mui/lab';
import {
  Button,
  Chip,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import SelectInput from '@components/form/select-input/SelectInput';
import {Box, maxHeight, Stack, useTheme} from '@mui/system';
import FormConstants from '@shared/constants/FormConstants';
import {t} from 'i18next';
import {ReactElement, useEffect, useRef, useState} from 'react';
import FormProvider from 'src/minimal-components/hook-form/form-provider';
import {useParams, useLocation} from 'react-router-dom';
import {PulseLoader} from 'react-spinners';
import {BASE_MENU_ITEM, BASE_RECORD_ID} from 'src/routes/BaseRoute';
import {emailValidator} from '@shared/utils/Validate';
import {FormControlDiv} from '../../module-search-filter/ModuleSearchFilterStyle';
import InfoIcon from '@mui/icons-material/Info';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {
  getLMSResultsData,
  getSearchResultsData
} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {enqueueSnackbar} from 'notistack';
import EncryptUtils from 'src/utils/EncryptUtils';
import {useAppContext} from '@context/AppContext';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import {useForm, Controller} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
interface FilterStateProps {
  formError: string;
  uiFields: Array<any>;
  dropDownValues: Array<any>;
  dropdownLoader: boolean;
  selectionListLoader: boolean;
  patientForm: boolean;
  accessForm: boolean;
  userForm: boolean;
  selectionListData: any;
  legacyAppValue: string;
  selections: string[];
  selectSubModuleValue: string;
  searchLoader: boolean;
  moduleAcessSelected: string;
}
interface BasicFormProps {
  tabname: string;
  formdata: any;
}
interface categoryOptions {
  id: number;
  value: number;
  label: string;
}

interface FormValues {
  name: string;
  course_type_id: number;
  category: categoryOptions[] | undefined;
  duration: number;
  durationTypeID: number;
  code: string;
  short_description: string;
  sharable_url: string;
}
const BasicsForm: React.FC<BasicFormProps> = props => {
  const theme = useTheme();
  const params: any = useParams();
  const location = useLocation();
  const sourceSystemOptions = useRef();
  const menuItem = new URLSearchParams(location?.search).get(BASE_MENU_ITEM);
  const menuItem1 = new URLSearchParams(location?.search).get('section');
  const menuItem2 = new URLSearchParams(location?.search).get('subsection');
  const uniqueid = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [uiFieldsData, setUIFieldsData] = useState<any>(props.formdata);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uiData, setUiData] = useState<FormValues>();
  const [dropDownData, setDropDownData] = useState<any[]>([]);
  const {
    appState: {applicationName}
  } = useAppContext();
  const init = async () => {
    try {
      setIsPageLoading(true);
      if (props.formdata) {
        setUIFieldsData(props.formdata || {});
        const {sql_data} = props.formdata['AssessmentSetUpForm'];
        const data: any = {
          sql_data: sql_data,
          operation: 'GETQUESTIONFORMOPTIONS'
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestData
        });
        setDropDownData((prevData: any[]) => {
          const resultData = result.data; // Assuming `result.data` contains the JSON object

          const transformedData = Object.keys(resultData).map(key => ({
            Name: key,
            Values: resultData[key].map((item: any) => ({
              label: item.label,
              value: item.value
            }))
          }));

          return [...(prevData || []), ...transformedData];
        });
        const {sql_datas} = props.formdata['create_sql'];
        const datas: any = {
          sql_data: sql_datas,
          data: {id: uniqueid,course_overview_id: uniqueid},
          operation: 'SEARCH'
        };
        const encryptRequestDatas = EncryptUtils.encryptedData(datas);
        const results = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestDatas
        });
        const transformedResult = results.data.map((item: any) => {
          return {
            ...item,
            // Parse JSON fields or set them to empty arrays if they are null
            category: item.category
            // Add any additional transformations here if needed
          };
        });
        setUiData(transformedResult[0]);
      } else {
        setUIFieldsData({});
      }
      setIsPageLoading(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setIsPageLoading(false);
    }
  };
  useEffect(() => {
    init();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const schema = yup.object({
    name: yup.string().required('Name is required'),
    course_type_id: yup.number().required('Type is required'),
    category: yup.array().of(
      yup.object({
        id: yup.number().required(),
        value: yup.number().required(),
        label: yup.string().required()
      })
    ),
    duration: yup.number().nullable().typeError('Duration must be a number'),
    durationTypeID: yup.number().nullable(),
    code: yup.string(),
    short_description: yup.string(),
    sharable_url: yup.string().url('Invalid URL')
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: {errors}
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: {
      name: uiData?.name || '',
      course_type_id: uiData?.course_type_id || 1,
      category: uiData?.category || undefined,
      duration: uiData?.duration || null,
      durationTypeID: uiData?.durationTypeID || null,
      code: uiData?.code || '',
      short_description: uiData?.short_description || '',
      sharable_url: uiData?.sharable_url || ''
    }
  });
  useEffect(() => {
    if (uiData) {
      reset({
        name: uiData.name || '',
        course_type_id: uiData.course_type_id || 1,
        category: uiData.category || undefined,
        duration: uiData.duration || null,
        durationTypeID: uiData.durationTypeID || null,
        code: uiData.code || '',
        short_description: uiData.short_description || '',
        sharable_url: uiData.sharable_url || ''
      });
    }
  }, [uiData, reset]);
  const onSubmit = async (fieldsData: any) => {
    try {
      setIsSubmitting(true);
      const {sql_datas} = props.formdata['create_sql'];
      fieldsData.category = fieldsData?.category
        ? JSON.stringify(fieldsData.category)
        : '[]';
      fieldsData.id = uniqueid;
      fieldsData.course_overview_id = uniqueid;
      const datas: any = {
        sql_data: sql_datas,
        data: fieldsData,
        operation: 'UPDATE'
      };
      const encryptRequestDatas = EncryptUtils.encryptedData(datas);
      const results = await getLMSResultsData(applicationName, 'LMS', {
        tk: encryptRequestDatas
      });
      const transformedResult = results.data.map((item: any) => {
        return {
          ...item,
          // Parse JSON fields or set them to empty arrays if they are null
          category: item.category
          // Add any additional transformations here if needed
        };
      });
      setUiData(transformedResult[0]);
      setIsSubmitting(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setIsSubmitting(false);
    }
  };
  const renderSaveButton = () => {
    return (
      <LoadingButton
        type="submit"
        variant="contained"
        loading={isSubmitting}
        sx={{
          // mr: 2,
          backgroundColor: theme.palette.primary.dark
        }}>
        {t('PRIVATE.COMMON.SAVE', {ns: 'private'})}
      </LoadingButton>
    );
  };
  return isPageLoading ? (
    <Stack
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      minHeight={'60vh'}>
      <LoadingScreen />
    </Stack>
  ) : (
    <Box
      sx={{
        backgroundColor: 'white',
        borderRadius: '8px',
        maxWidth: '100% !important',
        py: '3vh'
      }}>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid sx={{p: 1}} container spacing={2}>
          {/* Name */}
          <Grid item xs={12} sm={8}>
            <div style={{display: 'flex', paddingBottom: '1.5vh'}}>
              <h4 style={{paddingRight: '1vh'}}>Name</h4>
              <div>
                <Tooltip title={'Give a title that describes the course'}>
                  <InfoIcon
                    style={{width: '0.6em', height: '0.6em'}}
                    color="action"
                  />
                </Tooltip>
              </div>
            </div>
            <Controller
              name="name"
              control={control}
              render={({field}) => (
                <TextField
                  {...field}
                  label="Name"
                  fullWidth
                  error={!!errors.name}
                  helperText={errors.name?.message}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0000003b',
                      borderWidth: '1.8px'
                    }
                  }}
                />
              )}
            />
          </Grid>

          {/* Type */}
          <Grid item xs={12} sm={6}>
            <div style={{display: 'flex', paddingBottom: '1.5vh'}}>
              <h4 style={{paddingRight: '1vh'}}>Type</h4>
              <div>
                <Tooltip
                  title={
                    'Select the type of course that reflects the mode, features and options available to the learner.'
                  }>
                  <InfoIcon
                    style={{width: '0.6em', height: '0.6em'}}
                    color="action"
                  />
                </Tooltip>
              </div>
            </div>
            <Controller
              name="course_type_id"
              control={control}
              render={({field}) => (
                <FormControlDiv>
                  <SelectInput
                    enableDefaultOption
                    name="course_type_id"
                    label="Course Type"
                    disabled
                    options={
                      dropDownData.find(
                        (item: {Name: string}) => item.Name === 'CourseType'
                      )?.Values || []
                    }
                    value={field.value}
                    fullWidth
                    // onOpenCallback={(event: any) =>
                    //   handleLegacyAppChange(event, 'Maximumallowedattempts')
                    // }
                    onChange={(event: any) => {
                      field.onChange(event);
                      // setMaxAttempts(Number(event.target.value));
                      // setState(prevState => ({
                      //   ...prevState,
                      //   formError: ''
                      // }));
                    }}
                    optionValueKey={'value'}
                    optionLabelKey={'label'}
                    fetchOptionsFromOnOpenTrigger
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: '30vh', // Set dropdown max height
                          overflowY: 'auto' // Enable scrolling
                        }
                      }
                    }}
                  />
                </FormControlDiv>
              )}
            />
          </Grid>

          {/* Category */}
          <Grid item xs={12} sm={6}>
            <div style={{display: 'flex', paddingBottom: '1.5vh'}}>
              <h4 style={{paddingRight: '1vh'}}>Category</h4>
              <div>
                <Tooltip
                  title={
                    'To help users search faster, select the right category for this course'
                  }>
                  <InfoIcon
                    style={{width: '0.6em', height: '0.6em'}}
                    color="action"
                  />
                </Tooltip>
              </div>
            </div>
            <Controller
              name="category" // This must match the form field name in your `yup` schema
              control={control} // From `react-hook-form`
              render={({field: {onChange, value}}) => (
                <RHFAutocomplete
                  name="category"
                  placeholder="+ Category"
                  multiple
                  disableCloseOnSelect
                  options={
                    (dropDownData.find(
                      (item: {Name: string; Values: categoryOptions[]}) =>
                        item.Name === 'CourseCategoryType'
                    )?.Values || []) as readonly categoryOptions[]
                  }
                  isOptionEqualToValue={(option, values) => {
                    return option?.value === values.value;
                  }}
                  getOptionLabel={option =>
                    (option as categoryOptions).label || ''
                  }
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {option.label}
                    </li>
                  )}
                  onChange={(event, newValue: any[]) => {
                    // Calculate the least value of the existing IDs (or default to -1 if none exist)
                    const minId = Math.min(
                      ...newValue
                        .map(item => item.id || 0)
                        .filter(id => id < 0), // Filter only negative IDs
                      0 // Default to 0 if no negative IDs are found
                    );

                    const updatedValue = newValue.map(item => {
                      if (!item.id) {
                        // If the item is new and has no ID, assign a new negative ID
                        return {...item, id: minId - 1}; // Subtract -1 from the least negative ID
                      }
                      return item; // Keep existing items as is
                    });

                    onChange(updatedValue); // Update the value in `react-hook-form`
                  }}
                  value={value || []}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0000003b',
                      borderWidth: '1.8px'
                    }
                  }}
                  renderTags={(selected, getTagProps) => {
                    return selected.map((option, index) => (
                      <Chip
                        {...getTagProps({index})}
                        key={option.value}
                        label={option.label}
                        size="small"
                        color="info"
                        variant="soft"
                      />
                    ));
                  }}
                />
              )}
            />
          </Grid>

          {/* Duration */}
          <Grid sx={{display: 'flex', alignItems: 'end'}} item xs={12}>
            <Grid item xs={6}>
              <div style={{display: 'flex', paddingBottom: '1.5vh'}}>
                <h4 style={{paddingRight: '1vh'}}>Duration</h4>
                <div>
                  <Tooltip
                    title={
                      'The users will get an idea about the time taken to complete the course'
                    }>
                    <InfoIcon
                      style={{width: '0.6em', height: '0.6em'}}
                      color="action"
                    />
                  </Tooltip>
                </div>
              </div>
              <Controller
                name="duration"
                control={control}
                render={({field}) => (
                  <TextField
                    {...field}
                    label="Duration"
                    fullWidth
                    type="number"
                    error={!!errors.duration}
                    helperText={errors.duration?.message}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#0000003b',
                        borderWidth: '1.8px'
                      }
                    }}
                  />
                )}
              />
            </Grid>

            {/* Duration Unit */}
            <Grid item xs={6}>
              <Controller
                name="durationTypeID"
                control={control}
                render={({field}) => (
                  <FormControlDiv>
                    <SelectInput
                      enableDefaultOption
                      name="durationTypeID"
                      label="Duration Type"
                      variant="filled"
                      options={
                        dropDownData.find(
                          (item: {Name: string}) =>
                            item.Name === 'CourseDurationType'
                        )?.Values || []
                      }
                      value={field.value}
                      fullWidth
                      // onOpenCallback={(event: any) =>
                      //   handleLegacyAppChange(event, 'Maximumallowedattempts')
                      // }
                      onChange={(event: any) => {
                        field.onChange(event);
                        // setMaxAttempts(Number(event.target.value));
                        // setState(prevState => ({
                        //   ...prevState,
                        //   formError: ''
                        // }));
                      }}
                      optionValueKey={'value'}
                      optionLabelKey={'label'}
                      focused={true}
                      fetchOptionsFromOnOpenTrigger
                      classes={{
                        FilledInputClasses: {
                          focused: true
                        }
                      }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: '30vh', // Set dropdown max height
                            overflowY: 'auto' // Enable scrolling
                          }
                        }
                      }}
                    />
                  </FormControlDiv>
                )}
              />
            </Grid>
          </Grid>
          {/* Course Code */}
          <Grid item xs={12}>
            <div style={{display: 'flex', paddingBottom: '1.5vh'}}>
              <h4 style={{paddingRight: '1vh'}}>Course Code</h4>
              <div>
                <Tooltip title={'Assign a unique code to refer to this course'}>
                  <InfoIcon
                    style={{width: '0.6em', height: '0.6em'}}
                    color="action"
                  />
                </Tooltip>
              </div>
            </div>
            <Controller
              name="code"
              control={control}
              render={({field}) => (
                <TextField
                  {...field}
                  label="Course Code"
                  fullWidth
                  error={!!errors.code}
                  helperText={errors.code?.message}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0000003b',
                      borderWidth: '1.8px'
                    }
                  }}
                />
              )}
            />
          </Grid>

          {/* Description */}
          <Grid item xs={12}>
            <div style={{display: 'flex', paddingBottom: '1.5vh'}}>
              <h4 style={{paddingRight: '1vh'}}>Description</h4>
              <div>
                <Tooltip
                  title={
                    'Provide a description about the course to be displayed in the course card'
                  }>
                  <InfoIcon
                    style={{width: '0.6em', height: '0.6em'}}
                    color="action"
                  />
                </Tooltip>
              </div>
            </div>
            <Controller
              name="short_description"
              control={control}
              render={({field}) => (
                <TextField
                  {...field}
                  label="Description"
                  fullWidth
                  multiline
                  rows={2}
                  error={!!errors.short_description}
                  helperText={errors.short_description?.message}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0000003b',
                      borderWidth: '1.8px'
                    }
                  }}
                />
              )}
            />
          </Grid>

          {/* Sharable URL */}
          {/* <Grid item xs={12}>
            <div style={{display: 'flex', paddingBottom: '1.5vh'}}>
              <h4 style={{paddingRight: '1vh'}}>Sharable URL</h4>
              <div>
                <Tooltip
                  title={
                    'The users will be able to share the url of the course with others'
                  }>
                  <InfoIcon
                    style={{width: '0.6em', height: '0.6em'}}
                    color="action"
                  />
                </Tooltip>
              </div>
            </div>
            <Controller
              name="sharable_url"
              control={control}
              render={({field}) => (
                <TextField
                  {...field}
                  label="Sharable URL"
                  fullWidth
                  disabled
                  error={!!errors.sharable_url}
                  helperText={errors.sharable_url?.message}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0000003b',
                      borderWidth: '1.8px'
                    }
                  }}
                />
              )}
            />
          </Grid> */}
        </Grid>
        <Stack
          display="flex"
          alignItems="baseline"
          justifyContent="space-between"
          flexDirection="row"
          sx={{mt: 2, p: 1}}>
          <Grid item xs={12} display="flex" sm={6} md={12}>
            {renderSaveButton()}
          </Grid>
        </Stack>
      </form>
    </Box>
  );
};
export default BasicsForm;
